import cx from 'classnames';
import { capfirst, intcomma } from 'journalize';
import { Component, h, VNode } from 'preact';

import PartyPill from './PartyPill';
import PureComponent from './PureComponent';

import { isCanvass } from '../endpoints';

import formatPercent from '../utils/format-percent';

interface Props {
  ballotName: string;
  candidateId: string;
  contestIsCalled: boolean;
  isIncumbent: boolean;
  isWinner: boolean;
  party: string;
  totalVotesInContest: number;
  votes: number;
}

class CandidateRow extends Component<Props> {
  static Header: VNode;
  static countyHeader: VNode;
  static columnCount: number;

  render() {
    const {
      ballotName,
      contestIsCalled,
      isIncumbent,
      isWinner,
      isViewable,
      party,
      totalVotesInContest,
      votes,
    } = this.props;
  

    let rowClass = cx('candidate', 'contest__candidate-row');

    let checkClass = cx('check', {
      'dem-winner': party == 'Democrat',
      'rep-winner': party == 'Republican',
      'lib-winner': party == 'Libertarian',
      'ind-winner': party == 'Independent',
      'gre-winner': party == 'Green',
    });

    if (!isViewable) {
      rowClass += ' race__candidate-row--hidden';
    }

    const checkmark = '\u2713';

    return (
      <tr class={rowClass}>
        <td class="candidate__cell candidate__party">
          <PartyPill party={party} />
        </td>
        <th class="candidate__cell candidate__name">
          {isWinner && isCanvass == true && (
            <span class={checkClass}>{checkmark}</span>
          )}
          {isWinner && isCanvass == true ? (
            <span class={checkClass}>{ballotName}</span>
          ) : (
            ballotName
          )}{' '}
          {isIncumbent && (
            <span class="pill pill--basic" title="Currently holds this seat">
              Incumbent
            </span>
          )}
        </th>
        <td class="candidate__cell candidate__votes">{intcomma(votes)}</td>
        <td class="candidate__cell candidate__pct">
          {formatPercent(votes, totalVotesInContest)}
          <span class="candidate__pct-symbol">%</span>
        </td>
      </tr>
    );
  }
}

CandidateRow.defaultProps = {
  contestIsCalled: false,
  isViewable: true,
};

CandidateRow.Header = (
  <thead>
    <tr>
      <th class="contest__candidate-header" colSpan={2}>
        Candidates
      </th>
      <th class="contest__candidate-header contest__candidate-header--numeric">
        Votes
      </th>
      <th class="contest__candidate-header contest__candidate-header--numeric">
        Pct.
        <span class="candidate__pct-symbol">%</span>
      </th>
    </tr>
  </thead>
);

CandidateRow.countyHeader = (
  <thead>
    <tr>
      <th class="contest__candidate-header" colSpan={2}>
        Candidates
      </th>
      <th class="contest__candidate-header contest__candidate-header--numeric">
        Votes
      </th>
      <th class="contest__candidate-header contest__candidate-header--numeric">
        Pct.
        <span class="candidate__pct-symbol">%</span>
      </th>
    </tr>
  </thead>
);

CandidateRow.columnCount = 4;

export default CandidateRow;
